/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { license } from '../../actions/License/licenseActions';
import LogoBig from '../../assets/svgs/LogoBig';
import LogoBigSpinner from '../../assets/svgs/LogoBigSpinner';
import Websites from '../SettingsPage/Websites';

const Welcome = ({ className }) => {
    const [isFetch, setFetch] = useState(true);
    const [licensesList, setLicense] = useState([]);

    const dispatch = useDispatch();

    useEffect(() => {
        const loader = async () => {
            const response = await dispatch(license());
            setFetch(false);
            setLicense(response);
        };
        loader();
    }, []);

    return (
        <div className={className}>
            <>
                {isFetch && (
                    <div className="Spinner__Logo">
                        <LogoBigSpinner />
                    </div>
                )}
                {isFetch ? (
                    <span>در حال بارگزاری ...</span>
                ) : (
                    <Websites websites={licensesList} />
                )}
            </>
        </div>
    );
};

Welcome.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(Welcome)`
    display: flex;
    flex-flow: column wrap;
    align-items: center;

    span {
        font-size: 20px;
        font-weight: 400;
        line-height: 35px;
        color: #fafafa;
        margin-top: 1.25em;
    }

    h2 {
        color: #fff;
        font-weight: bold;
    }

    .Spinner__Logo {
        path {
            fill: #fff;
        }
    }

    .Welcome__Licenses {
        width: 100%;

        > div {
            direction: ltr;
            display: flex;
            flex-flow: row wrap;
            align-items: center;
            justify-content: center;
            max-width: 310px;
            height: 53px;
            border-radius: 9px;
            background: #e8ebff;
            margin: 10px auto;
            cursor: pointer;

            h3 {
                color: #0d1fa1;
            }
        }
    }

    ${Websites} {
        max-height: 50vh;
        overflow: auto;
        display: block;
        text-align: center;

        > span {
            margin-bottom: 10px;
        }

        > div {
            margin: 6px auto;
        }
    }
`;
